// blakfy-cookie/src/i18n/translations/fa.js — Persian translations

export default {
  title: "تنظیمات کوکی",
  intro:
    "این سایت از کوکی‌ها برای بهبود تجربه شما استفاده می‌کند. برای جزئیات بیشتر سیاست کوکی ما را مطالعه کنید.",
  policyLink: "سیاست کوکی",
  acceptAll: "پذیرش همه",
  rejectAll: "رد همه",
  preferences: "تنظیمات",
  save: "ذخیره انتخاب‌ها",
  close: "بستن",
  cat: {
    essential: {
      title: "کوکی‌های ضروری",
      desc: "برای عملکرد اصلی سایت لازم است. غیرفعال کردن آن‌ها امکان‌پذیر نیست.",
      always: "همیشه فعال",
    },
    analytics: {
      title: "کوکی‌های تحلیلی",
      desc: "برای جمع‌آوری آمار ناشناس بازدیدکنندگان استفاده می‌شود.",
    },
    marketing: {
      title: "کوکی‌های بازاریابی",
      desc: "برای تبلیغات شخصی‌سازی‌شده و هدف‌گذاری مجدد استفاده می‌شود.",
    },
    functional: {
      title: "کوکی‌های عملکردی",
      desc: "برای به یادآوری تنظیماتی مانند زبان و پوسته استفاده می‌شود.",
    },
  },
  placeholder: {
    title: "محتوا مسدود شد",
    desc: "برای مشاهده این محتوا باید کوکی‌های {category} را مجاز کنید.",
    cta: "اجازه دادن",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
